<template>
  <div class="invite-rules-root" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k005') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="rules-content">
      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title">{{ $t('lang.HostessRank.k013') }}</p>
        <p class="rules-row">1. {{ $t('lang.HostessRank.k014') }}</p>
        <p class="rules-row">2. {{ $t('lang.HostessRank.k015') }}</p>
        <!-- <p class="rules-row ">3. {{ $t('lang.HostessRank.k016') }}</p> -->
        <MyPLabel class="rules-row" :str="`3. ${$t('lang.HostessRank.k016')}`" :numsOption="[{ value: limitTime }]" />
        <p class="rules-row">4. {{ $t('lang.HostessRank.k017') }}</p>
        <p class="rules-row">5. {{ $t('lang.HostessRank.k018') }}</p>

        <div v-if="baseInfo && baseInfo.userRankRewardDTO" class="zone-block">
          <div class="zone-item">
            <div v-if="baseInfo.userRankRewardDTO.areaDesc === 'Brazil'">{{ $t('lang.HostessRank.k008') }}</div>
            <div v-else-if="baseInfo.userRankRewardDTO.areaDesc === 'Latin America'">{{ $t('lang.HostessRank.k009') }}</div>
            <div v-else-if="baseInfo.userRankRewardDTO.areaDesc === 'Middle East'">{{ $t('lang.HostessRank.k010') }}</div>
            <div v-else-if="baseInfo.userRankRewardDTO.areaDesc === 'Indonesia'">{{ $t('lang.HostessRank.k011') }}</div>
            <div v-else>{{ $t('lang.HostessRank.k012') }}</div>
          </div>
        </div>
      </div>

      <div class="rules-block">
        <p class="rules-title">{{ $t('lang.HostessRank.k004') }}</p>
        <!-- <p class="rules-row ">1. {{ $t('lang.HostessRank.k019') }}</p> -->
        <MyPLabel class="rules-row" :str="`1. ${$t('lang.HostessRank.k019')}`" :numsOption="[{ value: limitTime }]" />
        <p class="rules-row">2. {{ $t('lang.HostessRank.k020') }}</p>
        <p class="rules-row">3. {{ $t('lang.HostessRank.k021') }}</p>
        <p class="rules-row">4. {{ $t('lang.HostessRank.k022') }}</p>
        <p class="rules-row">5. {{ $t('lang.HostessRank.k023') }}</p>

        <div v-if="baseInfo" class="list-table">
          <div class="list-fields">
            <div class="field field1">{{ $t('lang.BaseCommon.k070') }}</div>
            <div class="field field2">
              {{ $t('lang.BaseCommon.k073') }}
              <img :src="getMatchImg('beans')" />
            </div>
          </div>
          <div class="list-fields" v-for="(item, index) in baseInfo.rankRewardDTOs" :key="index">
            <div class="bd-field field1">{{ item.range }}</div>
            <div class="bd-field field2">{{ item.rewardCount }}</div>
          </div>
        </div>
      </div>

      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title">{{ $t('lang.HostessRank.k024') }}</p>
        <p class="rules-row">1. {{ $t('lang.HostessRank.k025') }}</p>
        <p class="rules-row sub-row">
          <span>•</span>
          <span>{{ $t('lang.HostessRank.k026') }}</span>
        </p>
        <p class="rules-row sub-row">
          <span>•</span>
          <span>{{ $t('lang.HostessRank.k027') }}</span>
        </p>

        <p class="rules-row">2. {{ $t('lang.HostessRank.k028') }}</p>
        <p class="rules-row sub-row">
          <span>•</span>
          <span>{{ $t('lang.HostessRank.k029') }}</span>
        </p>
        <p class="rules-row sub-row">
          <span>•</span>
          <span>{{ $t('lang.HostessRank.k030') }}</span>
        </p>
        <p class="rules-row sub-row">
          <span>•</span>
          <span>{{ $t('lang.HostessRank.k031') }}</span>
        </p>

        <p class="rules-row">3. {{ $t('lang.HostessRank.k032') }}</p>
        <p class="rules-row sub-row">
          <span>•</span>
          <span>{{ $t('lang.HostessRank.k033') }}</span>
        </p>
        <p class="rules-row sub-row">
          <span>•</span>
          <span>{{ $t('lang.BaseCommon.k021') }}</span>
        </p>
      </div>

      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title">{{ $t('lang.BaseCommon.k022') }}</p>
        <p class="rules-row">1. {{ $t('lang.BaseCommon.k023') }}</p>
        <p class="rules-row">2. {{ $t('lang.HostessRank.k034') }}</p>
        <p class="rules-row">3. {{ $t('lang.BaseCommon.k024') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetHostessRankCfgApi } from '@/api/imee.js'
import { pageCssVars } from './z-style-cfg.js'

export default {
  mixins: [pageCssVars],
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
      baseInfo: null,
      limitTime: '',
    }
  },
  methods: {
    handleBack() {
      this.goPrevious()
    },
    getRules() {
      apiGetHostessRankCfgApi().then((resData) => {
        if (resData) {
          if (resData.rankRewardDTOs && resData.rankRewardDTOs.length) {
            resData.rankRewardDTOs.forEach((item) => {
              if (item.rankStart === item.rankEnd) {
                item.range = `${item.rankStart}`
                return
              }
              if (item.rankStart < item.rankEnd) {
                item.range = `${item.rankStart}-${item.rankEnd}`
              }
            })
          }

          if (resData.userRankRewardDTO && resData.userRankRewardDTO.settleTime) {
            this.limitTime = resData.userRankRewardDTO.settleTime || '18:00'
          }

          this.baseInfo = resData
        }
      })
    },
  },
  created() {
    this.getRules()

    // let uid = this.getUid()
    // window.localStorage.setItem(`cacheRulesTipsShow${uid}`, 'showed')
  },
}
</script>
<style lang="scss" scoped>
.invite-rules-root {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .van-bar-block {
    background: #f9f9fb;
  }

  .rules-content {
    flex: 1;
    width: 100%;
    background-color: #f9f9fb;
    overflow-y: scroll;
  }

  .rules-block {
    background-color: #ffffff;
    padding: 16px 24px;
    margin-bottom: 10px;

    .deliver-line {
      width: 327px;
      height: 1px;
      margin: 0 auto;
      transform: rotateX(45deg);
      background: #ededed;
    }

    .zone-block {
      width: 100%;
      overflow: hidden;
      .zone-item {
        float: left;
        width: 50%;
        margin-bottom: 16px;
        color: #333333;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-400);
        line-height: var(--lh-body-24);
        & > div {
          padding: 8px 10px;
          border-radius: 20px;
          display: inline-flex;
          align-items: center;
        }
      }
    }

    .more-btn {
      min-width: 150px;
      margin: 0 auto;
      padding: 10px 0;
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      line-height: var(--lh-body-24);
      color: var(--hr-theme-color);
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 12px;
        height: 13px;
        margin-left: 4px;
        transform: rotateZ(90deg);
      }
      &.expanded {
        img {
          transform: rotateZ(270deg);
        }
      }
    }

    .list-table {
      background-color: #fafafa;
      border-radius: 10px;
      padding: 5px 0;
      .list-fields {
        width: 100%;
        display: flex;
        margin: 14px 0;
        .field {
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-400);
          line-height: var(--lh-label-18);
          color: #b2b2b2;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 14px;
            height: 14px;
            margin: 0 2px;
          }
        }
        .field1 {
          width: 50%;
        }
        .field2 {
          width: 50%;
        }

        .bd-field {
          min-height: 36px;
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          line-height: var(--lh-body-24);
          color: #333333;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .rules-title {
    font-family: var(--string-font);
    font-size: var(--fs-16);
    font-weight: var(--fw-700);
    line-height: var(--lh-body-24);
    color: #333333;
    width: 100%;
    text-align: center;
    padding: 16px 0 24px;
  }

  .rules-row {
    font-family: var(--string-font);
    font-size: var(--fs-16);
    font-weight: var(--fw-400);
    line-height: var(--lh-body-24);
    color: #333333;
    margin-bottom: 12px;
    letter-spacing: -0.5px;

    .beans-img {
      width: 18px;
      height: 18px;
      display: inline-block;
      vertical-align: middle;
    }

    .color-purple {
      color: var(--hr-theme-color);
    }
  }

  .sub-row {
    padding-left: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    span {
      display: inline-block;
      vertical-align: baseline;
      &:last-child {
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.invite-rules-root {
  .custom-nav-block {
    background-color: #f9f9fb;
  }
  .van-nav-bar {
    .van-nav-bar__content {
      .van-nav-bar__left {
        .left-nav {
          width: 20px;
          height: 20px;
        }
        .tit-left {
          font-weight: var(--fw-400);
          line-height: var(--lh-headline-28);
        }
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .invite-rules-root {
    .rules-block {
      .zone-block {
        .zone-item {
          & > div {
            img {
              margin-left: 4px;
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>
